import React from 'react';
import { shopInfo } from '../data/mock';

const Hero = () => {
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-amber-50 via-rose-50 to-cream-50"></div>
      
      {/* Decorative Elements */}
      <div className="absolute top-20 left-10 w-64 h-64 bg-amber-200/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-rose-200/20 rounded-full blur-3xl"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto">
        {/* Logo */}
        <div className="mb-8 animate-fade-in">
          <img 
            src={shopInfo.logo} 
            alt="Global Boutique" 
            className="w-64 sm:w-80 lg:w-96 h-auto mx-auto drop-shadow-2xl"
          />
        </div>

        {/* Tagline */}
        <h1 className="hero-title mb-6 animate-slide-up">
          {shopInfo.tagline}
        </h1>

        {/* Experience Badge */}
        <div className="inline-block mb-8 animate-slide-up-delay">
          <div className="px-6 py-3 bg-white/80 backdrop-blur-sm rounded-full shadow-lg border border-amber-200">
            <p className="text-lg font-semibold text-amber-800">
              {shopInfo.experience}
            </p>
          </div>
        </div>

        {/* Location */}
        <p className="text-xl text-gray-700 mb-8 animate-fade-in-delay">
          {shopInfo.location.area}, {shopInfo.location.city}
        </p>

        {/* CTA Button */}
        <div className="animate-bounce-slow">
          <button 
            onClick={() => document.getElementById('services').scrollIntoView({ behavior: 'smooth' })}
            className="cta-button"
          >
            Explore Our Collection
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-gray-400 rounded-full flex justify-center">
          <div className="w-1.5 h-3 bg-gray-400 rounded-full mt-2"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
